import React from 'react'
import moment from 'moment'

const TimeSelectField = props => {
	const {
		configData,
		restaurantKey,
		reservationTime,
		handleReservationTime
	} = props

	const hotelLabels = configData.hotel.labels[0]

	// Initialize default values for rendering time options
	let selectOptions = [],
			availableTimes = [],
			startTime = moment('17:00', 'HH:mm'),
			endTime = moment('23:45', 'HH:mm'),
			interval = moment('00:15', 'HH:mm').format('m')

	// Set time based on ENV variables
	if (process.env.REACT_APP_COMPONENT_RESTAURANT_TIME_INTERVAL) {
		interval = moment(process.env.REACT_APP_COMPONENT_RESTAURANT_TIME_INTERVAL, ' HH:mm').format('m')
	}
	if (process.env.REACT_APP_COMPONENT_RESTAURANT_OPTIONS_START_TIME) {
		startTime = moment(process.env.REACT_APP_COMPONENT_RESTAURANT_OPTIONS_START_TIME, ' HH:mm')
	}
	if (process.env.REACT_APP_COMPONENT_RESTAURANT_OPTIONS_END_TIME) {
		endTime = moment(process.env.REACT_APP_COMPONENT_RESTAURANT_OPTIONS_END_TIME, ' HH:mm')
	}

	// Construct time range based on property config start time
	while (startTime <= endTime) {
		availableTimes.push(moment(startTime).format('HH:mm'))
		startTime = moment(startTime).add(interval, 'minutes')
	}

	for (let time in availableTimes) {
		const currentTime = availableTimes[time]

		selectOptions.push(
			<option
				key={currentTime}
				value={currentTime}
			>
				{moment(currentTime, 'HH:mm').format('hh:mm a')}
			</option>
		)
	}

	return (
		<div className="u-form-col">
			<label
				className="u-form-label"
				id={ 'restaurantTimeLabel-' + restaurantKey }
				htmlFor={ 'restaurantTime-' + restaurantKey }
			>
				{hotelLabels && hotelLabels.time ? hotelLabels.time : 'Time' }
			</label>

			<select
				name={ 'restaurantTime-' + restaurantKey }
				className='u-form-select'
				onChange={ (e) => handleReservationTime(e.target.value) }
				value={ reservationTime}
				aria-labelledby={ 'restaurantTimeLabel-' + restaurantKey }
			>
				<option value="0" disabled>{ hotelLabels.selectTime ? hotelLabels.selectTime : 'Select Time' }</option>
				{ selectOptions }
			</select>
		</div>
	)
}

export default TimeSelectField



// WEBPACK FOOTER //
// ./src/components/forms/restaurantForm/elements/TimeSelectField.js